import { useRef, useState, ChangeEvent, useEffect } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { ImageUploadType } from 'shared/ui/ImageUpload/types';
import { green } from '@mui/material/colors';
import CheckIcon from '@mui/icons-material/Check';

// TODO refactor
export const ImageUpload = ({ callback, isLoading, isSuccess, title = 'Медиа', src, silent }: ImageUploadType) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const [oldImage] = useState(src);
  const [currentImage, setCurrentImage] = useState<File>();

  const selectImage = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files as FileList;

    if (silent && selectedFiles?.[0]) {
      setCurrentImage(selectedFiles?.[0]);
      callback(selectedFiles?.[0]);
    }
  };

  const buttonSx = {
    ...(isSuccess && { bgcolor: green[500], '&:hover': { bgcolor: green[700] } }),
  };

  useEffect(() => {
    if (src instanceof File) {
      setCurrentImage(src);
    }
  }, [src]);

  return (
    <div style={{ marginBottom: '24px' }}>
      <input
        style={{ display: 'none' }}
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={selectImage}
      />

      {oldImage && typeof oldImage === 'string' && (
        <>
          <Typography variant="subtitle1">Загруженное {title}</Typography>
          <Box
            component="img"
            sx={{ height: 100, width: 100, objectFit: 'cover' }}
            alt={oldImage}
            src={oldImage}
          />
        </>
      )}
      <Typography variant="subtitle1">{title}</Typography>

      {currentImage && (
        <Box
          component="img"
          sx={{ height: 250, width: '100%', objectFit: 'contain' }}
          alt={currentImage.name}
          src={URL.createObjectURL(currentImage)}
        />
      )}

      <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
        <Button onClick={() => inputRef.current?.click()}>Выбрать</Button>

        {!silent
          ? currentImage && (
              <Box sx={{ m: 1, position: 'relative' }}>
                <Button
                  variant="contained"
                  sx={buttonSx}
                  disabled={isLoading}
                  onClick={() => callback(currentImage)}
                >
                  {isSuccess ? 'Загружено' : 'Загрузить'} {isSuccess && <CheckIcon />}
                </Button>

                {isLoading && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: green[500],
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-12px',
                      marginLeft: '-12px',
                    }}
                  />
                )}
              </Box>
            )
          : null}
      </Box>
    </div>
  );
};
